import Enchantef1 from '../../../Media/Fasilitas BSD/Enchante/Enchante (1).webp'
import Enchantef2 from '../../../Media/Fasilitas BSD/Enchante/Enchante (2).webp'
import Enchantef3 from '../../../Media/Fasilitas BSD/Enchante/Enchante (3).webp'
import Enchantef4 from '../../../Media/Fasilitas BSD/Enchante/Enchante (4).webp'




const Enchantefimages =[
Enchantef1,Enchantef2,Enchantef3,Enchantef4
]

export default Enchantefimages;